module.exports = __webpack_public_path__ + "img/angle-sort.7e64ba11.svg";